import { inferScanTypeFromCode, type ScanInventoryType } from 'Utils/scanInventoryType'

export function extractScannedCode(scanData: any) {
  const rawValue = scanData[0].rawValue.trim()
  const serialMatch = rawValue.match(/\$Serial\+([^$\|\r\n]+)/i)
  return serialMatch?.[1]?.trim() ?? rawValue
}

export function extractSoNo(rawValue: string): string | undefined {
  const match = rawValue.match(/\$Batch\+([^$\|\r\n]+)/i)
  return match?.[1]?.trim() || undefined
}

export function extractItemId(rawValue: string): string | undefined {
  const match = rawValue.match(/Item\+(.+?)\$?Batch/i)
  return match?.[1]?.trim() || undefined
}

export interface InventoryScanPayload {
  rawValue: string
  inventoryCode: string
  type: ScanInventoryType
  itemId?: string
  soNo?: string
}

export function parseInventoryScanInput(rawValue: string): InventoryScanPayload {
  const trimmed = rawValue.trim()
  const itemId = extractItemId(trimmed)
  const soNo = extractSoNo(trimmed)

  return {
    rawValue: trimmed,
    inventoryCode: extractScannedCode([{ rawValue: trimmed }]),
    type: inferScanTypeFromCode(trimmed),
    ...(itemId ? { itemId } : {}),
    ...(soNo ? { soNo } : {}),
  }
}
